<ng-container>
  <div *ngIf="isTakingOver || !isFlagrDone; else normalView" class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
  <ng-template #normalView>
    <div class="appform-header">
      <appform-header [activeMenuOrder]="activeQuestionSetOrder" (modeChange)="updateMenuOrder($event)"></appform-header>
    </div>
    <div *ngIf="readOnly">
      <appform-quick-guide [readOnly]="readOnly" [formData]="formData"></appform-quick-guide>
    </div>
    <div class="appform-container">
      <div class="container-navigation">
        <appform-question-set-navigation
          [activeMenuOrder]="activeQuestionSetOrder"
          [activeQuestionSet]="activeQuestionSet"
          (menuOrderChange)="updateMenuOrder($event)"
        >
        </appform-question-set-navigation>
      </div>

      <div class="container-section">
        <h4 class="section-header">Insurance Application</h4>
        <div *ngIf="(isAppFormRedirected$ | async) !== true; else sdkquestion">
          <appform-question-set
            [isContactInfoReady]="isContactInfoReady"
            [isProductInfoReady]="isProductInfoReady"
            [isBusinessTypeReady]="isBusinessTypeReady"
            [isGeneralInfoReady]="isGeneralInfoReady"
            [activeMenuOrder]="activeQuestionSetOrder"
            (questionSetUpdate)="updateFormState($event)"
            [readOnly]="readOnly"
            [formData]="formData"
            [isAppFormReady$]="isAppFormReady$"
            (businessTypeLoad)="updateApplicationState($event)"
            [isAppSyncedWithBP$]="isAppSyncedWithBP$"
          >
          </appform-question-set>
        </div>
        <ng-template #sdkquestion>
          <appform-sdk-question-set
            [formData]="formData"
            [activeQuestionSet]="activeQuestionSet"
            [activeMenuOrder]="activeQuestionSetOrder"
          ></appform-sdk-question-set>
        </ng-template>
      </div>
    </div>
  </ng-template>
</ng-container>
